import {CASINO_GAMES_IFRAME_ATTR} from './CasinoMarketingUtils';
import {isDesktop} from 'app/utils';

const CASINO_GAMES_IFRAME_SELECTOR = `[${CASINO_GAMES_IFRAME_ATTR}]`;
const CASINO_FILTER_SELECTOR = '.casino-filter';
const SITE_HEADER_OFFSET_PX = 70;
const SCROLL_RETRY_DELAY_MS = 50;
const SCROLL_MAX_ATTEMPTS = 20;

const getCasinoIframeScrollOffset = (): number => {
    const filter = document.querySelector(CASINO_FILTER_SELECTOR) as HTMLElement | null;
    const {position, top} = filter ? getComputedStyle(filter) : {position: '', top: ''};
    const isSticky = position === 'sticky' || position === '-webkit-sticky';

    if (!filter || !isSticky) {
        return SITE_HEADER_OFFSET_PX;
    }

    const stickyTop = parseInt(top, 10);

    return (Number.isFinite(stickyTop) ? stickyTop : SITE_HEADER_OFFSET_PX) + filter.offsetHeight;
};

export const scrollCasinoGridIframeIntoView = (
    element?: HTMLElement | null,
    behavior: ScrollBehavior = 'smooth',
    attempt = 0
): void => {
    if (!isDesktop()) {
        return;
    }

    const iframeHost = element ?? document.querySelector(CASINO_GAMES_IFRAME_SELECTOR) as HTMLElement | null;

    if (!iframeHost) {
        if (attempt < SCROLL_MAX_ATTEMPTS) {
            window.setTimeout(
                () => scrollCasinoGridIframeIntoView(element, behavior, attempt + 1),
                SCROLL_RETRY_DELAY_MS
            );
        }

        return;
    }

    const runScroll = (): void => {
        const scrollOffset = getCasinoIframeScrollOffset();
        const {top} = iframeHost.getBoundingClientRect();
        const scrollTop = top + window.scrollY - scrollOffset;

        window.scrollTo({behavior, top: Math.max(0, scrollTop)});
    };


    requestAnimationFrame(() => runScroll());
};
